import script from "./MenueDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./MenueDefault.vue?vue&type=script&setup=true&lang=js"

import "./MenueDefault.vue?vue&type=style&index=0&id=5486b2df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5486b2df"]])

export default __exports__